import SceneUtils from "../utils/sceneUtils";
import ScrollContainer from "./scrollContainer";
import {setupButtonClick} from "../utils/ui";

export default class CreditsPanel {
    static preload(scene){
    }

    constructor({scene}) {
        this.scene = scene;

        this.panel = this.scene.add.image(
            this.scene.game.config.width / 2,
            this.scene.game.config.height / 2,
            "board"
        );
        this.panel.setScale(0.6);

        this.panel.setInteractive();

        this.creditsText = this.scene.add.text(this.scene.game.config.width / 2,
            this.scene.game.config.height / 2 - 200, 'Credits',
            {
                fill: "#141",
                fontSize: "60px",
                fontFamily: "Splurge"
            });

        this.creditsText.setOrigin(0.5);


        this.scrollContainer = new ScrollContainer({
            scene: this.scene,
            x: this.scene.game.config.width / 2,
            y: this.scene.game.config.height / 2 + 50,
            width: 400,
            height: 400,
            content: `GAME IDEA | \nJUZ\n\nFONT | \nhttps://de.cooltext.com/\n\nCHARACTER | \nhttps://gtibo.itch.io/hooded-fox\n\nENVIRONMENT | \nThis work is based on "Low Poly Nature Free ✓" (https://sketchfab.com/3d-models/low-poly-nature-free-b9b9d627d62b46418ba61de1cc1df557) by _Alexandr (https://sketchfab.com/a_l_e_x_a_n_d_e_r) licensed under CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)`,
            scrollMode: 0
        })

        this.homeBtn =  this.scene.add.image(
            this.scene.game.config.width - 70,
            70,
            "btn_home"
        );

        this.homeBtn.setScale(0.15);

        setupButtonClick(this.homeBtn, () => {
            if(this.hidden) return;
            setTimeout(() => {this.hide();}, 0)
            this.homeBtn.actived = false;
        })

        this.hide();
    }


    hide(){
        this.hidden = true;
        this.panel.visible = false;
        this.creditsText.visible = false;
        this.scrollContainer.visible = false;
        this.homeBtn.visible = false;

        this.panel.setDepth(1);
        this.creditsText.setDepth(1);
        this.scrollContainer.setDepth(1);
        this.homeBtn.setDepth(1);
    }

    show(){
        this.panel.visible = true;
        this.creditsText.visible = true;
        this.scrollContainer.visible = true
        this.homeBtn.visible = true;

        this.panel.setDepth(2);
        this.creditsText.setDepth(2);
        this.scrollContainer.setDepth(2);
        this.homeBtn.setDepth(2);

        setTimeout(() => {
            this.hidden = false;
        },0)
    }
}